
// create the config file datas here
export const TRUSTED_BY_BRANDS_DATAS = {
    
    // GENERAL APP INDIVIDUAL COURSE CATEGORY ITEMS
    BRANDS: [

        {
            "img": "/app_images/trusted_by_brands/brand-01.png",
            "width": 88,
            "height": 30
        },
        {
            "img": "/app_images/trusted_by_brands/brand-02.png",
            "width": 160,
            "height": 23
        },
        {
            "img": "/app_images/trusted_by_brands/brand-03.png",
            "width": 96,
            "height": 30
        },
        {
            "img": "/app_images/trusted_by_brands/brand-04.png",
            "width": 160,
            "height": 26
        },
        {
            "img": "/app_images/trusted_by_brands/brand-05.png",
            "width": 112,
            "height": 30
        }
        
    ]
      

};